var map = {
	"./company_happytablebi.jpg": "2700",
	"./company_historybg.jpg": "ae9e",
	"./company_intro1.jpg": "232f",
	"./company_intro2.jpg": "5abc",
	"./company_intro3.jpg": "bd3c",
	"./company_logo1.jpg": "f682",
	"./company_logo2.jpg": "85ee",
	"./company_logo3.jpg": "2b9b",
	"./company_logo4.jpg": "611e",
	"./content_info1.jpg": "c4ef3",
	"./content_info2.jpg": "f32b",
	"./content_info3.jpg": "ba8a",
	"./content_partnership_bg.jpg": "3872",
	"./directions_map.jpg": "def5",
	"./gamemore_bg.jpg": "7879",
	"./happybrain_bg.jpg": "3be1",
	"./happybrain_info1.jpg": "e32c",
	"./happybrain_info2.jpg": "2826",
	"./happybrain_info3.jpg": "954c",
	"./happybrain_info4.jpg": "9235",
	"./happybrain_product1.jpg": "e0df",
	"./happybrain_product2.jpg": "5b0b",
	"./happybrain_product3.jpg": "0c3a",
	"./happybrain_product4.jpg": "5234",
	"./happytable_bg.jpg": "19b8",
	"./happytable_info1.jpg": "aabc",
	"./happytable_info2.jpg": "e699",
	"./happytable_info3.jpg": "0192",
	"./happytable_info4.jpg": "c317",
	"./happytable_info5.jpg": "4157",
	"./happytable_product1.jpg": "4206",
	"./happytable_product2.jpg": "76f5",
	"./happytable_product3.jpg": "fe15",
	"./happytable_product4.jpg": "454c",
	"./happytablet_bg.jpg": "d619",
	"./happytablet_info1.jpg": "064c",
	"./happytablet_info2.jpg": "1f1f",
	"./happytablet_info3.jpg": "80e9",
	"./happytablet_info4.jpg": "5f6b",
	"./happytablet_product2.jpg": "9847",
	"./happytablet_product3.jpg": "2098",
	"./happytablet_product4.jpg": "cdf0",
	"./m_main.jpg": "f19d",
	"./m_top_cognitive.jpg": "90a5",
	"./m_top_company.jpg": "2093",
	"./m_top_content&technic.jpg": "3c98",
	"./m_top_directions.jpg": "3d32",
	"./m_top_game.jpg": "93e8",
	"./m_top_happybrain.jpg": "93c5",
	"./m_top_happytable.jpg": "b01a",
	"./m_top_happytablet.jpg": "8e4a",
	"./m_top_news.jpg": "c23b",
	"./m_top_overview.jpg": "f23e",
	"./m_top_partner.jpg": "5bb4",
	"./m_top_reference.jpg": "ec22",
	"./main_btn01.jpg": "8c38",
	"./main_btn02.jpg": "9335",
	"./main_btn03.jpg": "9557",
	"./main_img.jpg": "d117",
	"./main_product.jpg": "eed1",
	"./main_technic.jpg": "5969",
	"./main_technic_1.jpg": "b576",
	"./main_technic_2.jpg": "22d9",
	"./main_technic_3.jpg": "8150",
	"./main_technic_4.jpg": "d86a",
	"./main_technic_5.jpg": "59d3",
	"./main_technic_6.jpg": "022c",
	"./mainpage_img.jpg": "7551",
	"./more_bg.jpg": "e8b7",
	"./overview_info1.jpg": "f80f",
	"./overview_info2.jpg": "30f8",
	"./overview_info3.jpg": "0d94",
	"./overview_infographic.jpg": "2b41",
	"./partner_ad.jpg": "be16",
	"./partner_bg.jpg": "df85",
	"./partner_kj.jpg": "d87c",
	"./partner_kn.jpg": "3b98",
	"./reference01.jpg": "0d70",
	"./reference02.jpg": "c794",
	"./reference03.jpg": "8545",
	"./reference04.jpg": "2174",
	"./reference05.jpg": "2277",
	"./reference06.jpg": "ee3d",
	"./reference07.jpg": "3ef1",
	"./reference08.jpg": "bad4",
	"./reference09.jpg": "f52b",
	"./reference10.jpg": "29ba",
	"./reference11.jpg": "be62",
	"./reference12.jpg": "63fd",
	"./reference13.jpg": "29bf",
	"./reference14.jpg": "b418",
	"./reference15.jpg": "4804",
	"./reference16.jpg": "b453",
	"./reference17.jpg": "f34c",
	"./reference18.jpg": "2e6a",
	"./reference19.jpg": "9448",
	"./reference20.jpg": "7dd8",
	"./reference21.jpg": "9d13",
	"./reference22.jpg": "c771",
	"./reference23.jpg": "b13b",
	"./reference24.jpg": "228a",
	"./reference25.jpg": "a41e",
	"./reference26.jpg": "97c1",
	"./reference27.jpg": "4945",
	"./reference28.jpg": "04f1",
	"./reference29.jpg": "4b38",
	"./reference30.jpg": "9a2f",
	"./reference31.jpg": "ffb7",
	"./reference32.jpg": "3d72",
	"./reference33.jpg": "ca9c",
	"./reference34.jpg": "ef80",
	"./reference35.jpg": "f1bf",
	"./reference36.jpg": "d57c",
	"./reference37.jpg": "b251",
	"./reference38.jpg": "cfc9",
	"./reference39.jpg": "211c",
	"./reference40.jpg": "1f8d",
	"./reference41.jpg": "5a04",
	"./reference42.jpg": "e303",
	"./reference43.jpg": "2df9",
	"./reference44.jpg": "3453",
	"./reference45.jpg": "9bcf",
	"./reference46.jpg": "1d6d",
	"./reference47.jpg": "5056",
	"./reference48.jpg": "185b",
	"./reference49.jpg": "ba12",
	"./reference50.jpg": "3fb9",
	"./reference51.jpg": "6ca5",
	"./reference52.jpg": "4071",
	"./reference53.jpg": "93b7",
	"./reference54.jpg": "b13a",
	"./reference55.jpg": "ec37",
	"./reference56.jpg": "8136",
	"./reference57.jpg": "012b",
	"./reference58.jpg": "9137",
	"./reference59.jpg": "9527",
	"./reference60.jpg": "f4e7",
	"./reference61.jpg": "1e6d",
	"./reference62.jpg": "e649",
	"./reference63.jpg": "6341",
	"./reference64.jpg": "fe2b",
	"./reference65.jpg": "7236",
	"./reference66.jpg": "a220",
	"./reference67.jpg": "edb1",
	"./reference68.jpg": "cf73",
	"./reference69.jpg": "f714",
	"./reference70.jpg": "7a81",
	"./top_cognitive.jpg": "bb26",
	"./top_company.jpg": "f806",
	"./top_content&technic.jpg": "94e7",
	"./top_directions.jpg": "e2f5",
	"./top_game.jpg": "e0ad",
	"./top_happybrain.jpg": "7ac4",
	"./top_happytable.jpg": "a49a",
	"./top_happytablet.jpg": "235a",
	"./top_news.jpg": "3e20",
	"./top_overview.jpg": "e975",
	"./top_partner.jpg": "de39",
	"./top_reference.jpg": "9438"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "84d8";